import { useState, useEffect } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { API_BASE } from "../api"; 


const TOTAL_PHASES = 5;
const STEPS_PER_PHASE = 5;

export default function usePhaseFlow() {

  const { sessionId, role, phase: phaseParam } = useParams();
  const location = useLocation();
  const navigate = useNavigate();

  const [phase, setPhase] = useState(Number(phaseParam) || 1);
  const [step, setStep] = useState(1);
  const [answer, setAnswer] = useState("");
  const [status, setStatus] = useState("active");
  const [isLoading, setIsLoading] = useState(false);
  const [showTransition, setShowTransition] = useState(false);

  // =========================
  // INIT FROM INTRO (?class=)
  // =========================
  useEffect(() => {

    const params = new URLSearchParams(location.search);
    const selectedClass = Number(params.get("class"));

    if (!selectedClass || role === "B") return;

    const key = `completedClasses_${sessionId}`;
    const completed = JSON.parse(localStorage.getItem(key) || "[]");

    if (completed.includes(selectedClass)) {
      navigate(`/module2/${sessionId}/${role}`);
      return;
    }

    setPhase(selectedClass);
    setStep(1);
    setStatus("active");

    navigate(`/module2/${sessionId}/${role}`, { replace: true });

  }, [location.search, sessionId, role, navigate]);

  // =========================
  // RESET ON PHASE PARAM
  // =========================
  useEffect(() => {

    if (!phaseParam) return;

    setPhase(Number(phaseParam));
    setStep(1);
    setStatus("active");

  }, [phaseParam]);

  // =========================
  // SUBMIT STEP
  // =========================
  async function submitStep() {

    if (!answer.trim() || isLoading) return null;

    setIsLoading(true);
    setShowTransition(true);

    const res = await fetch(`${API_BASE}/module2/phase/step`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        session_id: sessionId,
        role,
        phase,
        step,
        message: answer
      })
    });

    const data = await res.json();

    setAnswer("");

    setTimeout(() => {

      setShowTransition(false);
      setIsLoading(false);

      if (data?.ai_message?.toLowerCase().includes("waiting")) {
        setStatus("waiting");
      }

    }, 800);

    return data;
  }

  // =========================
  // NEXT STEP / PHASE
  // =========================
  function goNext() {

    if (step < STEPS_PER_PHASE) {
      setStep(prev => prev + 1);
      setStatus("active");
      return;
    }

    completePhase();
  }

  // =========================
  // COMPLETE PHASE
  // =========================
  async function completePhase() {

    if (phase > TOTAL_PHASES) {
      setStatus("finished");
      return;
    }

    setShowTransition(true);

    const res = await fetch(`${API_BASE}/module2/phase/complete`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        session_id: sessionId,
        role,
        phase
      })
    });

    const data = await res.json();

    if (data.status === "waiting") {
      setShowTransition(false);
      setStatus("waiting");
      return;
    }

    // =========================
    // SHRANI ZAKLJUČEN RAZRED
    // =========================
    const key = `completedClasses_${sessionId}`;
    const completed = JSON.parse(localStorage.getItem(key) || "[]");

    if (!completed.includes(phase)) {
      completed.push(phase);
      localStorage.setItem(key, JSON.stringify(completed));
    }

    navigate(`/module2/bridge/${sessionId}/${role}/${phase}`);

  }

  return {
    phase,
    step,
    answer,
    setAnswer,
    submitStep,
    goNext,
    status,
    isLoading,
    showTransition
  };

} 
